
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

interface ConversationHeaderProps {
  conversationId: string;
  companyName?: string;
}

const ConversationHeader = ({ 
  conversationId, 
  companyName
}: ConversationHeaderProps) => {
  // Create a shortened ID for display (first 8 characters)
  const shortId = conversationId.substring(0, 8);
  
  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center">
        <Button asChild variant="outline" size="sm" className="mr-4">
          <Link to="/conversations">
            <ChevronLeft className="h-4 w-4 mr-1" /> Back
          </Link>
        </Button>
        <h1 className="text-xl font-bold">
          {companyName ? `${companyName} Refund` : `Refund #${shortId}`}
        </h1>
      </div>
    </div>
  );
};

export default ConversationHeader;
